import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode("取消")
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" 确定 ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_select_option = _resolveComponent("a-select-option")
  const _component_a_select = _resolveComponent("a-select")
  const _component_a_form_item = _resolveComponent("a-form-item")
  const _component_a_col = _resolveComponent("a-col")
  const _component_a_row = _resolveComponent("a-row")
  const _component_a_divider = _resolveComponent("a-divider")
  const _component_a_input = _resolveComponent("a-input")
  const _component_a_form = _resolveComponent("a-form")
  const _component_a_button = _resolveComponent("a-button")
  const _component_a_modal = _resolveComponent("a-modal")

  return (_openBlock(), _createBlock(_component_a_modal, {
    visible: true,
    width: "600px",
    title: `${_ctx.modalState[_ctx.type]}外呼线路`,
    afterClose: _ctx.afterClose,
    onCancel: _ctx.afterClose,
    maskClosable: false
  }, {
    footer: _withCtx(() => [
      _createVNode(_component_a_button, {
        key: "back",
        onClick: _ctx.afterClose
      }, {
        default: _withCtx(() => [
          _hoisted_1
        ]),
        _: 1
      }, 8, ["onClick"]),
      (!_ctx.isView)
        ? (_openBlock(), _createBlock(_component_a_button, {
            key: "submit",
            type: "primary",
            loading: _ctx.loading,
            onClick: _ctx.onSubmit
          }, {
            default: _withCtx(() => [
              _hoisted_2
            ]),
            _: 1
          }, 8, ["loading", "onClick"]))
        : _createCommentVNode("", true)
    ]),
    default: _withCtx(() => [
      _createVNode(_component_a_form, {
        ref: "formRef",
        colon: false,
        validateOnRuleChange: true,
        model: _ctx.form,
        rules: _ctx.rules,
        "label-col": { style: {width: '100px'} },
        "wrapper-col": { span: 10 },
        class: "form-content"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_a_row, { gutter: 16 }, {
            default: _withCtx(() => [
              _createVNode(_component_a_col, { span: 12 }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_form_item, {
                    label: "外呼服务商",
                    name: "supplierType"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_select, {
                        disabled: _ctx.isView || _ctx.isEdit,
                        value: _ctx.form.supplierType,
                        "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => (_ctx.form.supplierType = $event)),
                        placeholder: "请选择外呼服务商",
                        onChange: _ctx.changeSupplierType
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.supplierOptions, (item) => {
                            return (_openBlock(), _createBlock(_component_a_select_option, {
                              key: item.value,
                              value: item.value
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(item.label), 1)
                              ]),
                              _: 2
                            }, 1032, ["value"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["disabled", "value", "onChange"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_a_col, { span: 12 }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_form_item, {
                    label: "外呼模式",
                    name: "wayType"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_select, {
                        disabled: _ctx.isView || _ctx.isEdit,
                        value: _ctx.form.wayType,
                        "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => (_ctx.form.wayType = $event)),
                        placeholder: "请选择外呼模式"
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.callLineOptions, (item) => {
                            return (_openBlock(), _createBlock(_component_a_select_option, {
                              key: item.value,
                              value: item.value
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(item.label), 1)
                              ]),
                              _: 2
                            }, 1032, ["value"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["disabled", "value"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_a_divider),
          (_ctx.form.supplierType === 0)
            ? (_openBlock(), _createBlock(_component_a_form_item, {
                key: 0,
                label: "外呼线路",
                name: ['configJson', 'callLine']
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_select, {
                    disabled: _ctx.isView,
                    value: _ctx.form.configJson.callLine,
                    "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => (_ctx.form.configJson.callLine = $event)),
                    placeholder: "选择外呼线路"
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.callLines, (item) => {
                        return (_openBlock(), _createBlock(_component_a_select_option, {
                          key: item.value
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(item.name), 1)
                          ]),
                          _: 2
                        }, 1024))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["disabled", "value"])
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (_ctx.form.supplierType === 1)
            ? (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
                _createVNode(_component_a_row, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_col, { span: 12 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_form_item, {
                          label: "线路帐号",
                          name: ['configJson', 'accountName']
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_input, {
                              disabled: _ctx.isView,
                              value: _ctx.form.configJson.accountName,
                              "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => (_ctx.form.configJson.accountName = $event)),
                              placeholder: "线路帐号"
                            }, null, 8, ["disabled", "value"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_col, { span: 12 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_form_item, {
                          label: "密码",
                          name: ['configJson', 'password']
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_input, {
                              disabled: _ctx.isView,
                              value: _ctx.form.configJson.password,
                              "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => (_ctx.form.configJson.password = $event)),
                              placeholder: "密码"
                            }, null, 8, ["disabled", "value"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_form_item, {
                  label: "account",
                  name: ['configJson', 'accountId']
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_input, {
                      disabled: _ctx.isView,
                      value: _ctx.form.configJson.accountId,
                      "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => (_ctx.form.configJson.accountId = $event)),
                      placeholder: "account"
                    }, null, 8, ["disabled", "value"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_form_item, {
                  label: "请求域名",
                  name: ['configJson', 'host']
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_input, {
                      disabled: _ctx.isView,
                      value: _ctx.form.configJson.host,
                      "onUpdate:value": _cache[7] || (_cache[7] = ($event: any) => (_ctx.form.configJson.host = $event)),
                      placeholder: "请求域名"
                    }, null, 8, ["disabled", "value"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_form_item, {
                  label: "APISecreKey",
                  name: ['configJson', 'secretKey']
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_input, {
                      disabled: _ctx.isView,
                      value: _ctx.form.configJson.secretKey,
                      "onUpdate:value": _cache[8] || (_cache[8] = ($event: any) => (_ctx.form.configJson.secretKey = $event)),
                      placeholder: "APISecreKey"
                    }, null, 8, ["disabled", "value"])
                  ]),
                  _: 1
                }),
                (_ctx.form.wayType === 3)
                  ? (_openBlock(), _createBlock(_component_a_form_item, {
                      key: 0,
                      label: "proxyUrl",
                      name: ['configJson', 'proxyUrl']
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_input, {
                          disabled: _ctx.isView,
                          value: _ctx.form.configJson.proxyUrl,
                          "onUpdate:value": _cache[9] || (_cache[9] = ($event: any) => (_ctx.form.configJson.proxyUrl = $event)),
                          placeholder: "proxyUrl"
                        }, null, 8, ["disabled", "value"])
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (_ctx.form.wayType === 0)
                  ? (_openBlock(), _createBlock(_component_a_form_item, {
                      key: 1,
                      label: "pbxId",
                      name: ['configJson', 'pbx']
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_input, {
                          disabled: _ctx.isView,
                          value: _ctx.form.configJson.pbx,
                          "onUpdate:value": _cache[10] || (_cache[10] = ($event: any) => (_ctx.form.configJson.pbx = $event)),
                          placeholder: "pbxId"
                        }, null, 8, ["disabled", "value"])
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (_ctx.form.wayType === 4)
                  ? (_openBlock(), _createBlock(_Fragment, { key: 2 }, [
                      _createVNode(_component_a_form_item, {
                        label: "文本服务号",
                        name: ['configJson', 'serviceNo']
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_input, {
                            disabled: _ctx.isView,
                            value: _ctx.form.configJson.serviceNo,
                            "onUpdate:value": _cache[11] || (_cache[11] = ($event: any) => (_ctx.form.configJson.serviceNo = $event)),
                            placeholder: "文本服务号"
                          }, null, 8, ["disabled", "value"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_a_form_item, {
                        label: "文件服务号",
                        name: ['configJson', 'serviceNoVoice']
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_input, {
                            disabled: _ctx.isView,
                            value: _ctx.form.configJson.serviceNoVoice,
                            "onUpdate:value": _cache[12] || (_cache[12] = ($event: any) => (_ctx.form.configJson.serviceNoVoice = $event)),
                            placeholder: "文件服务号"
                          }, null, 8, ["disabled", "value"])
                        ]),
                        _: 1
                      })
                    ], 64))
                  : _createCommentVNode("", true)
              ], 64))
            : _createCommentVNode("", true),
          (_ctx.form.supplierType === 2)
            ? (_openBlock(), _createBlock(_Fragment, { key: 2 }, [
                _createVNode(_component_a_form_item, {
                  label: "appId",
                  name: ['configJson', 'appId']
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_input, {
                      disabled: _ctx.isView,
                      value: _ctx.form.configJson.appId,
                      "onUpdate:value": _cache[13] || (_cache[13] = ($event: any) => (_ctx.form.configJson.appId = $event)),
                      placeholder: "appId"
                    }, null, 8, ["disabled", "value"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_form_item, {
                  label: "appToken",
                  name: ['configJson', 'appToken']
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_input, {
                      disabled: _ctx.isView,
                      value: _ctx.form.configJson.appToken,
                      "onUpdate:value": _cache[14] || (_cache[14] = ($event: any) => (_ctx.form.configJson.appToken = $event)),
                      placeholder: "appToken"
                    }, null, 8, ["disabled", "value"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_form_item, {
                  label: "appName",
                  name: ['configJson', 'appName']
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_input, {
                      disabled: _ctx.isView,
                      value: _ctx.form.configJson.appName,
                      "onUpdate:value": _cache[15] || (_cache[15] = ($event: any) => (_ctx.form.configJson.appName = $event)),
                      placeholder: "appName"
                    }, null, 8, ["disabled", "value"])
                  ]),
                  _: 1
                })
              ], 64))
            : _createCommentVNode("", true),
          _createVNode(_component_a_divider),
          _createVNode(_component_a_form_item, { label: "服务商后台登录" }, {
            default: _withCtx(() => [
              _createVNode(_component_a_input, {
                disabled: _ctx.isView,
                value: _ctx.form.configJson.url,
                "onUpdate:value": _cache[16] || (_cache[16] = ($event: any) => (_ctx.form.configJson.url = $event)),
                placeholder: "请输入登录网址"
              }, null, 8, ["disabled", "value"])
            ]),
            _: 1
          }),
          _createVNode(_component_a_form_item, { label: " " }, {
            default: _withCtx(() => [
              _createVNode(_component_a_input, {
                disabled: _ctx.isView,
                value: _ctx.form.configJson.account,
                "onUpdate:value": _cache[17] || (_cache[17] = ($event: any) => (_ctx.form.configJson.account = $event)),
                placeholder: "请输入帐号"
              }, null, 8, ["disabled", "value"])
            ]),
            _: 1
          }),
          _createVNode(_component_a_form_item, { label: " " }, {
            default: _withCtx(() => [
              _createVNode(_component_a_input, {
                disabled: _ctx.isView,
                value: _ctx.form.configJson.pass,
                "onUpdate:value": _cache[18] || (_cache[18] = ($event: any) => (_ctx.form.configJson.pass = $event)),
                placeholder: "请输入密码"
              }, null, 8, ["disabled", "value"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["model", "rules"])
    ]),
    _: 1
  }, 8, ["title", "afterClose", "onCancel"]))
}